<div class="row mb-3">
  <div class="col-md-6">
    <label>Tarifa:</label>
    <input class="form-control" [value]="tarifaDisplay" readonly />
  </div>
  <div class="col-md-6">
    <label>Estructura tarifaria:</label>
    <input class="form-control" [value]="estructuraTarifariaDisplay" readonly />
  </div>
</div>
<div class="table-responsive">
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z1 full-width-table"
  >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          color="primary"
          [disabled]="readonly"
          (change)="toggleAllRows()"
          [checked]="isAllSelected()"
          [inserminate]="isSomeSelected()"
        ></mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          color="primary"
          [disabled]="readonly"
          (change)="selection.toggle(row)"
          [checked]="selection.isSelected(row)"
        ></mat-checkbox>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="no">
      <th mat-header-cell *matHeaderCellDef>No.</th>
      <td mat-cell *matCellDef="let element">{{ element.no }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="identificacion">
      <th mat-header-cell *matHeaderCellDef>Identificación</th>
      <td mat-cell *matCellDef="let element">{{ element.identificacion }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="nombreUsuario">
      <th mat-header-cell *matHeaderCellDef>Nombre usuario</th>
      <td mat-cell *matCellDef="let element">{{ element.nombreUsuario }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="parentesco">
      <th mat-header-cell *matHeaderCellDef>Parentesco</th>
      <td mat-cell *matCellDef="let element">{{ element.parentesco }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="edad">
      <th mat-header-cell *matHeaderCellDef>Edad</th>
      <td mat-cell *matCellDef="let element">{{ element.edad }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="genero">
      <th mat-header-cell *matHeaderCellDef>Género</th>
      <td mat-cell *matCellDef="let element">{{ element.genero }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="fechaNacimiento">
      <th mat-header-cell *matHeaderCellDef>Fecha Nacimiento</th>
      <td mat-cell *matCellDef="let element">{{ element.fechaNacimiento }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="fechaAntiguedad">
      <th mat-header-cell *matHeaderCellDef>Fecha Antigüedad</th>
      <td mat-cell *matCellDef="let element">{{ element.fechaAntiguedad }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="anexo">
      <th mat-header-cell *matHeaderCellDef>Anexo</th>
      <td mat-cell *matCellDef="let element">{{ element.anexo }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="valorTarifaAnexo">
      <th mat-header-cell *matHeaderCellDef>Valor tarifa Anexo</th>
      <td mat-cell *matCellDef="let element">
        {{
          element.valorTarifaAnexo
            | currency: 'COP' : 'symbol-narrow' : '1.2-2' : 'es-CO'
        }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="valorTarifaPrograma">
      <th mat-header-cell *matHeaderCellDef>Valor tarifa Programa</th>
      <td mat-cell *matCellDef="let element">
        {{
          element.valorTarifaPrograma
            | currency: 'COP' : 'symbol-narrow' : '1.2-2' : 'es-CO'
        }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="totalTarifa">
      <th mat-header-cell *matHeaderCellDef>Total tarifa</th>
      <td mat-cell *matCellDef="let element">
        {{
          element.totalTarifa
            | currency: 'COP' : 'symbol-narrow' : '1.2-2' : 'es-CO'
        }}
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="footerTotals">
      <td mat-footer-cell *matFooterCellDef colspan="3">
        <p>
          <span class="text-danger">Total cuota actual + IVA</span>
          {{
            totalCuotaConIva | currency: 'COP' : 'symbol-narrow' : '1.2-2' : 'es-CO'
          }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="campaniaVigente">
      <th mat-header-cell *matHeaderCellDef>Campaña vigente</th>
      <td mat-cell *matCellDef="let element">{{ element.campaniaVigente }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="congelamiento">
      <th mat-header-cell *matHeaderCellDef>Congelamiento</th>
      <td mat-cell *matCellDef="let element">{{ element.congelamiento }}</td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr mat-footer-row *matFooterRowDef="footerColumns"></tr>
  </table>
</div>
